import {
  BUTTON_WIDTH,
  GAP_BETWEEN_BUTTONS,
  QUANTITY_OF_BUTTONS,
} from './constants.js';

export const getWrapperPaddingValue = (isHovered: boolean, scale: number) => {
  switch (isHovered) {
    case true: {
      return scale < 1 ? `${12 * scale}px 12px` : '12px 16px';
    }
    case false:
    default: {
      return scale < 1 ? `${12 * scale}px 12px` : '12px';
    }
  }
};

export const getContainerMaxWidth = (
  isDeleteButtonVisible: boolean,
  scale: number,
) => {
  if (!isDeleteButtonVisible) {
    return `calc(100% - ${(BUTTON_WIDTH + GAP_BETWEEN_BUTTONS) * scale}px)`;
  }

  return `calc(100% - ${
    (BUTTON_WIDTH + GAP_BETWEEN_BUTTONS) * QUANTITY_OF_BUTTONS * scale
  }px)`;
};
